import { LayoutHOC } from 'base/ui/layout/layout';
import createAddRoutingOrTransfer from '.';

export const createAddRoutingOrTransferPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createAddRoutingOrTransfer());
};
